module.exports = __webpack_public_path__ + "img/转型路线.33953995.png";